import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Field } from 'redux-form';
import { propBool, propNumber, propStr, } from '../../../../helpers/custom-prop-types';
const RangeField = ({ disabled, max, maxStr, min, minStr, name }) => (_jsxs("div", Object.assign({ className: 'form form-slider' }, { children: [_jsx("div", Object.assign({ className: 'range' }, { children: _jsx(Field, { component: 'input', name: name, props: {
                    className: 'input-form-slider',
                    disabled,
                    max,
                    min,
                    type: 'range',
                } }) })), _jsxs("ul", Object.assign({ className: 'range-labels' }, { children: [_jsx("li", { children: minStr }), _jsx("li", { children: '　' }), _jsx("li", { children: '　' }), _jsx("li", { children: '　' }), _jsx("li", { children: maxStr })] }))] })));
RangeField.propTypes = {
    disabled: propBool().isRequired,
    max: propNumber(),
    maxStr: propStr().isRequired,
    min: propNumber(),
    minStr: propStr().isRequired,
    name: propStr().isRequired,
};
RangeField.defaultProps = {
    max: 5,
    min: 1,
};
export default RangeField;
